import connectAsyncToRoom from '@webclient/state/slices/search-session/thunks/connectAsyncToRoom';
import createAsyncSearchThread from '@webclient/state/slices/search-session/thunks/createAsyncSearchThread';
import { roomInstance } from '@webclient/state/slices/search-session/utils/room-manager';
import { RootType } from '@webclient/state/store';

import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

type Payload =
  | {
      requestOrigin: 'search';
      searchThreadId: string;
      withAudio?: boolean;
    }
  | {
      requestOrigin: 'home';
      withAudio?: boolean;
    };

const searchAsyncOrchestrator = createAsyncThunk(
  'search/searchAsyncOrchestrator',
  async (payload: Payload, { dispatch, getState }) => {
    const state = getState() as RootType;
    const token = state.searchSession.token;
    const threadId = state.searchSession.threadId;
    const isRoomConnected = state.searchSession.isConnected;
    const status = state.searchSession.searchThreadStatus;
    const isSearchThreadAlreadyCreated = !!threadId && !!token;

    if (status === 'pending') return;
    const room = roomInstance.get();
    if (isSearchThreadAlreadyCreated && !!room && isRoomConnected) {
      if (payload.withAudio) {
        room.localParticipant.setMicrophoneEnabled(payload.withAudio);
      }

      return {
        token,
        threadId,
      };
    }

    if (isSearchThreadAlreadyCreated && !isRoomConnected) {
      await dispatch(
        connectAsyncToRoom({
          audio: payload.withAudio,
        }),
      );
      return {
        token,
        threadId,
      };
    }

    const isOriginFromSearch = payload.requestOrigin === 'search';
    const { payload: createSearchThreadPayload } = (await dispatch(
      createAsyncSearchThread({
        thread: isOriginFromSearch ? payload.searchThreadId : undefined,
        restart: isOriginFromSearch ? true : undefined,
      }),
    )) as PayloadAction<{
      token: string;
      threadId: string;
    }>;

    await dispatch(
      connectAsyncToRoom({
        audio: payload.withAudio,
      }),
    );

    return createSearchThreadPayload;
  },
);

export default searchAsyncOrchestrator;
